/**
 * 会员展示路由模块
 * 包含注册会员列表和详情页面
 */

const children = [
  {
    path: 'list',
    name: 'member_list',
    url: '/member/list',
    meta: { title: '注册会员', requiresAuth: false },
    component: () => import(/* webpackChunkName: "memberDisplay" */ '@/views/member/list.vue')
  },
  {
    path: 'detail/:id',
    name: 'member_detail',
    url: '/member/detail',
    meta: { title: '会员详情', requiresAuth: false },
    component: () => import(/* webpackChunkName: "memberDisplay" */ '@/views/member/detail.vue')
  }
];

export default {
  path: '/member',
  name: 'memberDisplay',
  meta: { title: '会员展示' },
  component: () => import('@/layout/user.vue'),
  children: children
};
